import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'colorSketchPopoverCssVarsParser',
})
export class ColorSketchPopoverCssVarsParserPipe implements PipeTransform {
  constructor() {}
  transform(value: string, element: Element): string {
    if (!value) {
      return 'transparent';
    }
    const pattern = /^var\(\s*(--[^,)\s]+)\s*(?:,.*)?\)$/;
    const match = pattern.exec(value);

    if (!match) {
      return value;
    }

    try {
      const computedStyleMap = element?.computedStyleMap();
      const styleProperty = computedStyleMap?.get(match[1]);
      return styleProperty?.toString() ?? 'transparent';
    } catch (error) {}
    return 'transparent';
  }
}
